import React from 'react'

export default (props => {
    const styles = { 
    }; 
    return (
        <div style = {{...styles}}>
        </div>
    )
})